;(function (angular, _, is) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('DisplayService', DisplayService)

  DisplayService.$inject = ['$state', '$timeout', '$uibModal', '$window', 'SnackService', '$transitions', '$uibModalStack', '$rootScope']

  /**
   * @ngdoc service
   * @name DisplayService
   * @description
   *  Provide with various helpers to display confirm modals, snacks, upload overlay...
   */
  function DisplayService ($state, $timeout, $uibModal, $window, SnackService, $transitions, $uibModalStack, $rootScope) {
    var self = this

    /**
     *
     */
    var uploadActivated = false

    /**
     *
     */
    var allowDropFiles = false

    /**
     *
     */
    var overlayVisible = false

    /**
     *
     */
    var sidebar = 0

    /**
     *
     */
    var dialogMessage = false

    /**
     *
     */
    var shortcutsModal = false

    var closeOptions = {}

    //
    _.extend(self, {
      // Public Attributes
      uploadActivated: uploadActivated,
      allowDropFiles: allowDropFiles,
      overlayVisible: overlayVisible,
      sidebar: sidebar,
      dialogMessage: dialogMessage,
      closeOptions: closeOptions,
      shortcutsModal: shortcutsModal,

      // Public Methods
      closeAll: closeAll,
      goBack: goBack,
      displayReportPending: displayReportPending,
      displayReportSuccess: displayReportSuccess,
      displayReportError: displayReportError,
      displayConfirm: displayConfirm,
      confirmDeletion: confirmDeletion,
      detailClient: detailClient,
      confirmEntityEdition: confirmEntityEdition,
      displaygoTo: displaygoTo,
      missingFacturXData
    })

    $transitions.onStart({}, function(transition) {
      // Remove modals on page changes
      $uibModalStack.dismissAll()
      $rootScope.loadingPage = true
    })
    $transitions.onSuccess({}, function(transition) {
      $rootScope.loadingPage = false
    })

    function detailClient (client, type) {
      $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/detail-client.html',
        resolve: {
          client: _.constant(client),
          type: type ? _.constant(type) : _.constant('client')
        },
        bindToController: true,
        size: 'lg',
        controllerAs: 'ctrl',
        controller: ['client', 'type', function (client, type) {
          this.client = client
          this.type = type
        }]
      })
    }
    function missingFacturXData (missingData, bulk = false) {
      $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/facturX-missing-data.html',
        resolve: {
          missingData: _.constant(missingData)
        },
        bindToController: true,
        size: 'lg',
        controllerAs: 'ctrl',
        controller: ['missingData', function (missingData) {
          this.missingData = missingData
          this.bulk = bulk
          this.getKey = (item) => { return Object.keys(item).join('') }
          this.requiredCompanyParamsInfos = {
            'companyInfo.name': 'Nom',
            'companyInfo.address.postalCode': 'Code postal',
            'companyInfo.address.addressLine1': 'Numéro et rue',
            'companyInfo.address.city': 'Ville',
            'companyInfo.vatIntracom': 'Numéro de TVA Intracommunautaire (TVA INTRACOM)',
            'companyInfo.siret': 'Numéro de SIRET',
            'client.label': 'Client : Nom de l\'entreprise',
            'client.address.postalCode': 'Client : Code postal',
            'client.address.addressLine1': 'Client : Adresse',
            'client.address.city': 'Client : Ville',
            'client.vatIntracom': 'Client : TVA intracommunautaire',
            'client.siret': 'Client : Numéro de SIRET',
            'invoiceRef': 'Facture en relation avec l\'avoir',
            'delivery.label': 'Zone de livraison : Nom de l\'entreprise',
            'delivery.address.postalCode': 'Zone de livraison : Code postal',
            'delivery.address.addressLine1': 'Zone de livraison : Adresse',
            'delivery.address.city': 'Zone de livraison : Ville',
            'delivery.vatIntracom': 'Zone de livraison : TVA intracommunautaire'
          }
        }]
      })
    }

    function confirmEntityEdition () {
      return $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/entity-edit-warning.html',
        size: 'lg'
      }).result
    }

    function goBack () {
      var currentRoute = $state.$current.name
      currentRoute = currentRoute.split('.')
      var backRoute = ''

      if (currentRoute.length > 0) {
        currentRoute.splice(currentRoute.length - 1, 1)
        backRoute = currentRoute.join('.')

        if (backRoute === 'orders') {
          return $state.go('orders.list')
        }
      } else {
        $window.history.back()
      }
    }

    /**
     * @ngdoc method
     * @name DisplayService.closeAll
     * @description Close all the artifices (search, sidebar)
     * @return void
     */
    function closeAll (options) {
      var action = function () {
      }
      action()
    }

    /**
     * @ngDoc method
     * @name DisplayService.displayReportPending
     * @description Display a modal while the request is being processed for an export
     * @param {string} reportType
     * The type of report being processed (xls, pdf...)
     */
    function displayReportPending (reportType, isArchived) {
      self.pendingReport = $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/report-pending.html',
        keyboard: false,
        bindToController: true,
        controllerAs: 'pending',
        resolve: {
          type: function () {
            return reportType
          }
        },
        controller: ['type', '$uibModalInstance', '$timeout', function (type, $uibModalInstance, $timeout) {
          this.type = type ? type.toUpperCase() : 'PDF'
          var self = this
          self.time = 10
          self.isArchived = isArchived
          self.archivable = ($state.current.name === 'interventions.show')
          self.textArchive = isArchived ? 'Désarchiver' : 'Archiver'
          var countdown = function () {
            $timeout(function () {
              self.time--
              if (self.time > 0) {
                countdown()
              } else {
                $uibModalInstance.dismiss()
              }
            }, 1000)
          }
          countdown()
        }]
      })
      return self.pendingReport
    }

    /**
     * @ngdoc method
     * @name DisplayService.displayReportSuccess
     * @description Request for report is successful, close previous modal and display success snack
     *
     */
    function displayReportSuccess () {
      SnackService.snack({
        text: 'La demande de génération de rapport a bien été enregistrée, vous recevrez un mail dans les plus brefs délais.',
        delay: 5000
      })
      $timeout(function () {
        self.pendingReport.dismiss()
      }, 10000)
    }

    /**
     * @ngdoc method
     * @name DisplayService.displayReportError
     * @description Request for report unsuccessful, alert the user.
     */
    function displayReportError () {
      $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/report-error.html'
      })
    }

    /**
     *  @ngdoc method
     *  @name DisplayService.confirmDeletion
     *  @description Util for deletion warning
     *  @returns {ng.promise} A promise resolved if the user confirms the deletion.
     */
    function confirmDeletion () {
      return displayConfirm('Supprimer',
        'Vous êtes sur le point de supprimer définitivement cet élément, êtes-vous sûr de vouloir continuer ? <br><br>' +
        'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous',
        'SUPPRIMER')
    }

    /**
     * Display a modal prompting the user to confirm an action
     *
     * @param {string} title
     * @param {string} message
     * @param {string} [strongConfirm] - if specified, will display an input for the user to write.
     *  Button will be enabled only if the input matches strongConfirm
     * @returns {ng.promise}
     */
    function displayConfirm (title, message, strongConfirm) {
      return $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/confirm.html',
        size: 'lg',
        resolve: {
          title: _.constant(title),
          message: _.constant(message),
          strongConfirm: _.constant(strongConfirm)
        },
        bindToController: true,
        controllerAs: 'confirm',
        controller: ['title', 'message', 'strongConfirm', function (title, message, strongConfirm) {
          this.title = title
          this.message = message
          this.strongConfirm = strongConfirm
        }]
      }).result
    }

    function displaygoTo (title, message) {
      return $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/goTo.html',
        size: 'lg',
        resolve: {
          title: _.constant(title),
          message: _.constant(message)
        },
        bindToController: true,
        controllerAs: 'go',
        controller: ['title', 'message', function (title, message) {
          this.title = title
          this.message = message
        }]
      }).result
    }
  }
})(window.angular, window._, window.is)
